import '@/libs/font-awesome';
import '@/libs/buefy';
import '@/libs/vue-clipboard';
import Vue from 'vue';
import VueShepherd from 'vue-shepherd';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import {
  WButton,
  WCounter,
  WDateTimeDisplay,
  WInput,
  WModal,
  WSelect,
} from '@/components';
import Closable from '@/directives/closable';
import breakpoints from '@/plugins/breakpoints';
import Snackbar from '@/plugins/snackbar';
import App from './App.vue';
import api from './plugins/api';
import store from './store';
import router from './router';

import '@/assets/tailwind.css';
import './plugins/filters';

Vue.config.productionTip = false;

// Components
Vue.component('w-button', WButton);
Vue.component('w-counter', WCounter);
Vue.component('w-date-time-display', WDateTimeDisplay);
Vue.component('w-input', WInput);
Vue.component('w-modal', WModal);
Vue.component('w-select', WSelect);

Vue.directive('closable', Closable);

// Plugins
Vue.use(api, { router, store });
Vue.use(breakpoints);
Vue.use(Snackbar);
Vue.use(VueShepherd);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: 'https://3a77f50273214c3b9dd61aac81ba7075@o78883.ingest.sentry.io/6069722',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['takeorder.tw', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
